import { Component, OnDestroy, OnInit } from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyPageBase } from '../../property-page-base';
import { LifeStyleSubCategoryEnum } from '@classifieds-sell/datalayer';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';

@Component({
    selector: 'property-summary-page',
    templateUrl: './property-summary-page.component.html',
    styleUrls: ['./property-summary-page.component.scss']
})
export class LifeStylePropertySummaryPageComponent
    extends PropertyPageBase
    implements OnInit, OnDestroy {
    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertySummary, draftFacade, routerFacade);
    }

    isDwellingSubcategory: boolean;

    // TODO: a better way to handle per field formatting on the summary page.
    // to get rid of a lot of non required code for each fields formatting etc

    ngOnInit(): void {
        super.onInit();
        this.isDwellingSubcategory = this.routerData.subCategory === LifeStyleSubCategoryEnum.dwelling;
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
